/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"
import "../styles/index.scss"
import CookieConsent from "react-cookie-consent"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query {
      wpgraphql {
        generalSettings {
          title
          url
        }
        menu(id: "dGVybToxMg==") {
          menuItems {
            nodes {
              id
              url
              label
            }
          }
        }
      }
    }
  `)

  const { title, url } = data.wpgraphql.generalSettings
  const remove = url.replace("/wp", "")
  const items = data.wpgraphql.menu.menuItems.nodes.map(item => ({
    ...item,
    url: item.url.replace(remove, ""),
  }))

  return (
    <>
      <Header siteTitle={title} menuItems={items} />
      <main>{children}</main>
      <footer className="footer__bottom bg-dark">
        <div className="grid-container">
          © {new Date().getFullYear()}, développé avec Gatsby JS, React JS et
          WordPress par{" "}
          <a
            href="https://developpeur-web-strasbourg.fr"
            target="_blank"
            rel="noreferrer"
          >
            Jérôme Dicharry
          </a>
        </div>
      </footer>

      <CookieConsent
        location="bottom"
        buttonText="J'ai compris"
        cookieName="gatsby-gdpr-google-analytics"
        style={{ background: "#2B373B" }}
        buttonStyle={{
          color: "#FFF",
          backgroundColor: "#508484",
          fontSize: "18px",
          padding: "14px 30px",
          borderRadius: "5px",
        }}
        expires={150}
      >
        Nous utilisons des cookies pour vous fournir la meilleure expérience
        utilisateur possible sur ce site. <br></br>
        <span style={{ fontSize: "12px" }}>
          Si vous continuez, nous considérons que vous est d'accord avec ce
          principe.
        </span>
      </CookieConsent>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
